import React, { useEffect, useRef } from "react";

export default function SlideInOutText({ txt = "", prevTxt = "", fontSize, slideInColor = "black", slideOutColor = "black", tag = "span", style = {}, italic = false,
  fontWeight = 900,
  fontFamily = "Cal Sans",
  interval = 4000,
  speed = 2000,
  round = 4000,
}) {
  const wrapperRef = useRef(null);

  const chars = txt.split("");
  const prevChars = prevTxt.split("");
  const Tag = tag;

  const getSlideOutColor = (i) => {
    if (Array.isArray(slideOutColor) && slideOutColor.length > 0) {
      return slideOutColor[i % slideOutColor.length];
    }
    return slideOutColor;
  };

  useEffect(() => {
    if (!wrapperRef.current) return;

    const animate = () => {
      const charSpans = wrapperRef.current?.querySelectorAll(".slide-char-inner");
      if (!charSpans) return;
      const timers = [];
      chars.forEach((ch, i) => {
        timers.push(setTimeout(() => {
          const span = charSpans[i];
          if (!span) return;
          span.style.transform = "translateY(-56%)";
          setTimeout(() => {
            span.style.transform = "translateY(-6%)";
          }, speed);
        }, i * round));
      });
    };

    animate(); // run immediately on mount
    const loop = setInterval(animate, interval);
    return () => clearInterval(loop);
  }, [txt, prevTxt, interval]);

  return (
    <Tag
      ref={wrapperRef}
      style={{
        display: "inline-block",
        fontWeight: fontWeight,
        fontSize: fontSize,
        fontStyle: italic ? "italic" : "normal",
        height: fontSize,
        overflow: "hidden",
        marginBottom: "4px",
        ...style,
      }}
    >
      {chars.map((ch, i) => (
        <span
          key={i}
          style={{
            display: "inline-block",
            verticalAlign: "top",
            overflow: "hidden",
            height: fontSize,
          }}
        >
          <span
            className="slide-char-inner"
            style={{
              display: "flex",
              flexDirection: "column",
              transition: "transform 0.4s cubic-bezier(.7,0,.3,1)",
              willChange: "transform",
              transform: "translateY(-6%)",
            }}
          >
            <span style={{ color: slideInColor, fontFamily: fontFamily, padding: "0px 1px", fontWeight: fontWeight, }}>{ch}</span>
            <span style={{ color: getSlideOutColor(i), fontFamily: fontFamily, padding: "0px 1px", fontWeight: fontWeight, }}>{prevChars[i] !== undefined ? prevChars[i] : ch}</span>
          </span>
        </span>
      ))}
    </Tag>
  );
}